import React from 'react';
import PropTypes from 'prop-types';
import Pagination from '../../../../shared/components/pagination/Pagination';

const EmployeesTablePagination = ({
  totalEmployees,
  perPage,
  currentPage,
  updatePagination,
}) => (
  <Pagination
    itemsCount={totalEmployees}
    itemsToShow={perPage}
    pageOfItems={currentPage}
    onChangePage={updatePagination}
  />
);

EmployeesTablePagination.propTypes = {
  totalEmployees: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  updatePagination: PropTypes.func.isRequired,
};

export default EmployeesTablePagination;
